export const AdminUserRoles = ['urn:*:roles:gelato:admin', 'urn:*:roles:client:admin'];

export const ClientAdminUserRole = 'urn:*:roles:client:admin';
